// utils/roleLinks.js
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

// Pure function to map role to default route
export function roleToTargetLink(role) {
    if (role === 'admin') return "/admin/users";
    if (role === 'user') return "/home/visits-overview/";
    if (role === 'visitUser') return "/company/visits-overview";
    if (role === 'visitor') return "/user/visits-overview";
    return "/";
}

// Hook to keep role in sync and provide the target link
export function useUserRoleTarget() {
    const [userRole, setUserRole] = useState(Cookies.get('userRole') || '');
    useEffect(() => {
        const updateRoleFromCookie = () => setUserRole(Cookies.get('userRole') || '');
        window.addEventListener('focus', updateRoleFromCookie);
        return () => window.removeEventListener('focus', updateRoleFromCookie);
    }, []);
    return { userRole, targetLink: roleToTargetLink(userRole) };
}